export interface permissions_type {
  [key: string]: Int32Array;
}

const permissions: permissions_type = {
  datacentercode: new Int32Array([1, 1, 1, 1, 1, 1]),
  login: new Int32Array([1, 1, 1, 1, 1, 1]),
  validation: new Int32Array([1, 1, 1, 1, 1, 1]),
  user_info: new Int32Array([1, 1, 1, 1, 1, 1]),
  clusters: new Int32Array([1, 1, 2, 0, 0, 0]),
  subrole_binding: new Int32Array([1, 1, 2, 0, 0, 0]),
  cluster_info: new Int32Array([1, 1, 2, 2, 0, 0]),
  cluster_metric: new Int32Array([1, 1, 2, 2, 0, 0]),
  cluster_config: new Int32Array([1, 1, 1, 1, 1, 0]),
  service_components: new Int32Array([1, 1, 2, 2, 0, 0]),
  workspaces: new Int32Array([1, 1, 2, 2, 3, 0]),
  workspacenames: new Int32Array([1, 1, 1, 1, 1, 1]),
  workspace_info: new Int32Array([1, 1, 2, 2, 3, 0]),
  workspace_metric: new Int32Array([1, 1, 2, 2, 3, 0]),
  workspacequotas: new Int32Array([1, 1, 1, 1, 1, 0]),
  workspace_scale: new Int32Array([1, 1, 1, 1, 1, 0]),
  scalequotas: new Int32Array([1, 1, 1, 1, 1, 0]),
  namespaces: new Int32Array([1, 1, 2, 2, 3, 4]),
  namespace_info: new Int32Array([1, 1, 2, 2, 3, 4]),
  namespace_metric: new Int32Array([1, 1, 2, 2, 3, 4]),
  namespacequotas: new Int32Array([1, 1, 1, 1, 1, 1]),
  namespace_scale: new Int32Array([1, 1, 1, 1, 1, 1]),
  deployments: new Int32Array([1, 1, 1, 1, 1, 1]),
  daemonsets: new Int32Array([1, 1, 1, 1, 1, 1]),
  jobs: new Int32Array([1, 1, 1, 1, 1, 1]),
  cronjobs: new Int32Array([1, 1, 1, 1, 1, 1]),
  statefulsets: new Int32Array([1, 1, 1, 1, 1, 1]),
  helm_chart: new Int32Array([1, 1, 1, 1, 1, 1]),
  config: new Int32Array([1, 1, 1, 1, 1, 1]),
  subscriptions: new Int32Array([1, 1, 1, 1, 1, 1]),
  monitor: new Int32Array([1, 1, 2, 2, 3, 4]),
  logging: new Int32Array([1, 1, 2, 2, 3, 4]),
  nodes: new Int32Array([1, 1, 2, 2, 0, 0]),
  node_info: new Int32Array([1, 1, 2, 2, 0, 0]),
  role: new Int32Array([1, 1, 1, 1, 1, 0]),
  rolebinding: new Int32Array([1, 1, 1, 0, 0, 0]),
  urls: new Int32Array([1, 1, 1, 1, 1, 1]),
  monitor_tag_folder: new Int32Array([1, 1, 1, 1, 1, 1]),
  monitor_dbs: new Int32Array([1, 1, 1, 1, 1, 1]),
  logs: new Int32Array([1, 1, 1, 1, 1, 1]),
  workloads: new Int32Array([1, 1, 1, 1, 1, 1]),
  env_url: new Int32Array([1, 1, 1, 1, 1, 1]),
  user_subscriptions: new Int32Array([1, 1, 0, 0, 0, 0]),
  version: new Int32Array([1, 1, 1, 1, 1, 1]),
  existence: new Int32Array([1, 1, 1, 1, 1, 1]),
  ingress: new Int32Array([1, 1, 1, 1, 1, 1]),
  ingress_seleted: new Int32Array([1, 1, 1, 1, 1, 1]),
  external: new Int32Array([1, 1, 1, 1, 1, 1]),
  ingress_event: new Int32Array([1, 1, 1, 1, 1, 1]),
  status: new Int32Array([1, 1, 1, 1, 1, 1]),
  change_replica: new Int32Array([1, 1, 1, 1, 1, 1]),
  cluster_init: new Int32Array([1, 1, 1, 1, 1, 1]),
  workload_yaml: new Int32Array([1, 1, 1, 1, 1, 1]),
  workload_edit_yaml: new Int32Array([1, 1, 1, 1, 1, 1]),
  pod_item: new Int32Array([1, 1, 1, 1, 1, 1]),
  pod_yaml: new Int32Array([1, 1, 1, 1, 1, 1]),
  pod_delete: new Int32Array([1, 1, 1, 1, 1, 1]),
  records: new Int32Array([1, 1, 1, 1, 1, 1]),
  podRestartAlarm: new Int32Array([1, 1, 1, 1, 1, 1]),
  pvc: new Int32Array([1, 1, 1, 1, 1, 1]),
  pv: new Int32Array([1, 1, 1, 1, 1, 1]),
  storage: new Int32Array([1, 1, 1, 1, 1, 1]),
};

const level: string[] = ["globalAdmin", "datacenterAdmin", "clusterAdmin", "clusterOwner", "workspaceOwner", "namespaceDeveloper"];

export { permissions, level };
